import React from "react";
import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "../../data/content";

export const ServicesGrid = () => {
  const scrollTo = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  const bookService = (service) => {
    window.dispatchEvent(new CustomEvent("cfs:select-service", { detail: service.apiValue }));
    scrollTo("#booking");
  };

  return (
    <section id="services" className="section-anchor py-16 sm:py-20" data-testid="services-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <h2 className="text-2xl sm:text-3xl font-semibold tracking-tight text-[color:var(--brand-navy)]">
            Choose Your Service
          </h2>
          <p className="mt-3 text-muted-foreground leading-relaxed">
            Click any service to schedule an appointment, or call us at{" "}
            <a href="tel:+13459280382" className="text-[color:var(--brand-sky)] font-medium hover:underline">
              345-928-0382
            </a>{" "}
            with questions.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
          {SERVICES.map((service, i) => {
            const Icon = service.icon;
            return (
              <motion.div
                key={service.id}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
              >
                <Card className="card-lift h-full border bg-white" data-testid="service-card">
                  <CardContent className="p-6 flex flex-col h-full">
                    <div className="h-14 w-14 rounded-2xl bg-[color:var(--brand-navy)] flex items-center justify-center mb-5">
                      <Icon className="h-7 w-7 text-[color:var(--brand-sky)]" />
                    </div>
                    <h3 className="font-heading font-semibold text-lg text-[color:var(--brand-navy)] leading-snug">
                      {service.title}
                    </h3>
                    <p className="mt-2.5 text-sm text-muted-foreground leading-relaxed flex-1">{service.description}</p>
                    <div className="mt-5 flex items-center gap-3">
                      <Button
                        size="sm"
                        className="bg-[color:var(--brand-navy)] hover:bg-[color:var(--brand-navy-2)] btn-lift"
                        onClick={() => bookService(service)}
                        data-testid={`service-book-${service.id}-button`}
                      >
                        Book Now <ArrowRight className="h-4 w-4 ml-1.5" />
                      </Button>
                      <button
                        onClick={() => scrollTo(service.anchor)}
                        className="text-sm font-medium text-[color:var(--brand-sky)] hover:underline"
                        data-testid={`service-details-${service.id}-link`}
                      >
                        See Details
                      </button>
                    </div>
                  </CardContent>
                </Card>
              </motion.div>
            );
          })}
        </div>

        <p className="mt-8 text-sm text-muted-foreground italic max-w-3xl">
          <strong>Please Note:</strong> Cayman Fingerprinting Services Ltd. is a private company providing fingerprint
          capture and submission services. We are not a government agency.
        </p>
      </div>
    </section>
  );
};
